/* GRATU × LOOP — interacciones globales (delegadas) */
(function () {
  'use strict';

  /* ---- Swatches en product cards: swap imagen + variante + precio ---- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-swatch]');
    if (!sw) return;
    var card = sw.closest('[data-pcard]');
    if (!card) return;
    var img = card.querySelector('[data-pcard-img]');
    var src = sw.getAttribute('data-img');
    if (img && src) {
      img.style.opacity = '0';
      var pre = new Image();
      pre.onload = function () { img.src = src; img.style.opacity = '1'; };
      pre.src = src;
    }
    var vid = sw.getAttribute('data-variant-id');
    var idInput = card.querySelector('[data-pcard-id]');
    if (vid && idInput) idInput.value = vid;
    var price = sw.getAttribute('data-price');
    var priceEl = card.querySelector('[data-pcard-price]');
    if (price && priceEl) priceEl.textContent = price;
    var onsale = sw.getAttribute('data-onsale') === '1';
    var wasEl = card.querySelector('[data-pcard-was]');
    if (wasEl) {
      var cmp = sw.getAttribute('data-compare');
      if (onsale && cmp) { wasEl.textContent = cmp; wasEl.style.display = ''; }
      else { wasEl.style.display = 'none'; }
    }
    var saveEl = card.querySelector('[data-pcard-save]');
    if (saveEl) {
      var sv = sw.getAttribute('data-save');
      if (onsale && sv) { saveEl.textContent = 'Ahorras ' + sv; saveEl.style.display = ''; }
      else { saveEl.style.display = 'none'; }
    }
    var label = card.querySelector('[data-pcard-color]');
    if (label) label.textContent = sw.getAttribute('data-value') || label.textContent;
    card.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('is-active'); });
    sw.classList.add('is-active');
  });

  /* ---- Reveal on scroll ---- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    var observe = function () {
      document.querySelectorAll('.lp-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
    };
    document.addEventListener('DOMContentLoaded', observe);
    observe();
  } else {
    document.querySelectorAll('.lp-reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- Complementa tu compra: carga recomendaciones dinámicas (Section Rendering API) ---- */
  if (!customElements.get('complement-list')) {
    customElements.define('complement-list', class extends HTMLElement {
      connectedCallback() {
        var url = this.dataset.url;
        // Sin url = manual (ya renderizado server-side). Si ya tiene filas, nada que hacer.
        if (!url || this._loaded || this.querySelector('[data-complement-row]')) return;
        this._loaded = true;
        this._load(url, 3);
      }
      _load(url, tries) {
        var self = this;
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('complement-list');
            var content = inner ? inner.innerHTML.trim() : '';
            if (content) {
              self.innerHTML = content;
            } else if (tries > 1) {
              // Arranque en frío de Shopify: la 1ª petición puede volver vacía. Reintenta.
              setTimeout(function () { self._load(url, tries - 1); }, 600);
            }
          })
          .catch(function () {});
      }
    });
  }

  /* ---- PDP: galería + selección de variantes ---- */
  function initProduct(root) {
    var dataEl = root.querySelector('[data-loop-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var main = root.querySelector('[data-loop-main]');
    var idInput = root.querySelector('[data-loop-id]');
    var nowEl = root.querySelector('[data-loop-now]');
    var compareEl = root.querySelector('[data-loop-compare]');
    var saveEl = root.querySelector('[data-loop-save]');
    var priceWrap = root.querySelector('[data-loop-price]');
    var addBtn = root.querySelector('[data-loop-add]');
    var addText = root.querySelector('[data-loop-add-text]');

    // estado de selección por posición (1-indexed)
    var selected = [];
    root.querySelectorAll('[data-loop-option]').forEach(function (opt) {
      var pos = parseInt(opt.getAttribute('data-position'), 10);
      var active = opt.querySelector('[data-loop-value].is-active');
      selected[pos] = active ? active.getAttribute('data-loop-value') : null;
    });

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return val === selected[i + 1]; });
      });
    }

    function swapMain(src) {
      if (!main || !src) return;
      main.style.opacity = '0';
      var pre = new Image();
      pre.onload = function () { main.src = src; main.style.opacity = '1'; };
      pre.src = src;
    }

    function setActiveThumb(mediaId) {
      if (mediaId == null) return;
      root.querySelectorAll('[data-loop-thumb]').forEach(function (t) {
        var on = String(t.getAttribute('data-media-id')) === String(mediaId);
        t.classList.toggle('is-active', on);
      });
    }

    function update() {
      var v = findVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addText) { addText.textContent = 'No disponible'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (nowEl) nowEl.textContent = v.price;
      if (priceWrap) priceWrap.classList.toggle('lp-price--sale', v.on_sale);
      if (compareEl) {
        if (v.on_sale && v.compare_at_price) { compareEl.textContent = v.compare_at_price; compareEl.style.display = ''; }
        else { compareEl.style.display = 'none'; }
      }
      if (saveEl) {
        if (v.on_sale && v.save) { saveEl.textContent = 'Ahorras ' + v.save; saveEl.style.display = ''; }
        else { saveEl.style.display = 'none'; }
      }
      if (addBtn) addBtn.disabled = !v.available;
      if (addText) addText.textContent = v.available ? 'Añadir al carrito' : 'Agotado';
      if (v.media_src) swapMain(v.media_src);
      setActiveThumb(v.media_id);
      // actualizar URL sin recargar
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    // clicks en swatches / pills
    root.querySelectorAll('[data-loop-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(btn.getAttribute('data-position'), 10);
        var val = btn.getAttribute('data-loop-value');
        selected[pos] = val;
        var optWrap = btn.closest('[data-loop-option]');
        optWrap.querySelectorAll('[data-loop-value]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var label = optWrap.querySelector('[data-loop-opt-current]');
        if (label) label.textContent = val;
        update();
      });
    });

    // sincronizar altura de la tira de thumbnails con la imagen principal (desktop)
    var stage = root.querySelector('.lp-pdp__stage');
    var thumbsWrap = root.querySelector('.lp-pdp__thumbs');
    function syncThumbHeight() {
      if (!stage || !thumbsWrap) return;
      if (window.innerWidth > 989) {
        root.style.setProperty('--lp-stage-h', stage.offsetHeight + 'px');
      } else {
        root.style.removeProperty('--lp-stage-h');
      }
    }
    syncThumbHeight();
    window.addEventListener('resize', syncThumbHeight);
    window.addEventListener('load', syncThumbHeight);
    if (main) { main.addEventListener('load', syncThumbHeight); }

    // thumbnails
    root.querySelectorAll('[data-loop-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        swapMain(t.getAttribute('data-full'));
        root.querySelectorAll('[data-loop-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // cantidad
    var qInput = root.querySelector('[data-loop-qinput]');
    root.querySelectorAll('[data-loop-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qInput) return;
        var n = parseInt(qInput.value, 10) || 1;
        n = b.getAttribute('data-loop-qty') === '+' ? n + 1 : Math.max(1, n - 1);
        qInput.value = n;
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-loop-product]').forEach(initProduct);
  });

  /* ---- Medir altura del announcement para apilar el header sticky ---- */
  function setAnnHeight() {
    var a = document.querySelector('.lp-ann-section');
    document.documentElement.style.setProperty('--lp-ann-h', (a ? a.offsetHeight : 0) + 'px');
  }
  document.addEventListener('DOMContentLoaded', setAnnHeight);
  window.addEventListener('resize', setAnnHeight);
  window.addEventListener('load', setAnnHeight);

  /* ---- Announcement bar rotativo ---- */
  function initAnnouncement(root) {
    var msgs = Array.prototype.slice.call(root.querySelectorAll('[data-ann-msg]'));
    if (msgs.length <= 1) return;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 4000;
    var prev = root.querySelector('[data-ann-prev]');
    var next = root.querySelector('[data-ann-next]');
    var pauseBtn = root.querySelector('[data-ann-pause]');
    var pauseIc = root.querySelector('[data-ann-pause-ic]');
    var current = 0, playing = true, timer = null;

    function show(i) {
      if (i < 0) i = msgs.length - 1;
      if (i >= msgs.length) i = 0;
      msgs[current].classList.remove('is-active');
      current = i;
      msgs[current].classList.add('is-active');
    }
    function tick() { show(current + 1); }
    function restart() { if (timer) clearInterval(timer); if (playing) timer = setInterval(tick, interval); }
    function setPlaying(on) {
      playing = on;
      if (pauseIc) pauseIc.textContent = on ? '❚❚' : '▶';
      restart();
    }
    if (prev) prev.addEventListener('click', function () { show(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(current + 1); restart(); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPlaying(!playing); });
    restart();
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lp-ann]').forEach(initAnnouncement);
  });

  /* ---- Hero carrusel (autoplay + paginación + barra) ---- */
  function initHeroCarousel(root) {
    var track = root.querySelector('[data-heroc-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-heroc-slide]'));
    var nums = Array.prototype.slice.call(root.querySelectorAll('[data-heroc-goto]'));
    var numsWrap = root.querySelector('[data-heroc-nums]');
    var bar = root.querySelector('[data-heroc-bar]');
    var fill = root.querySelector('[data-heroc-fill]');
    var prev = root.querySelector('[data-heroc-prev]');
    var next = root.querySelector('[data-heroc-next]');
    var pauseBtn = root.querySelector('[data-heroc-pause]');
    var pauseIc = root.querySelector('[data-heroc-pause-ic]');
    if (!track || slides.length === 0) return;

    var interval = parseInt(root.getAttribute('data-autoplay'), 10) || 5000;
    var current = 0;
    var playing = slides.length > 1;
    var timer = null;

    function scrollToIndex(i) {
      // Desplaza SOLO el track horizontalmente (nunca la página vertical)
      var sr = slides[i].getBoundingClientRect();
      var tr = track.getBoundingClientRect();
      var delta = (sr.left + sr.width / 2) - (tr.left + tr.width / 2);
      track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
    }
    function startProgress() {
      if (!fill) return;
      fill.style.transition = 'none';
      fill.style.width = '0%';
      void fill.offsetWidth; // reflow
      if (playing) {
        fill.style.transition = 'width ' + interval + 'ms linear';
        fill.style.width = '100%';
      }
    }
    function freezeProgress() {
      if (!fill) return;
      var w = getComputedStyle(fill).width;
      fill.style.transition = 'none';
      fill.style.width = w;
    }
    function setActive(i) {
      current = i;
      nums.forEach(function (n, idx) { n.classList.toggle('is-active', idx === i); });
      if (bar && numsWrap && nums[i]) { numsWrap.insertBefore(bar, nums[i].nextSibling); }
      if (prev) prev.disabled = (i === 0);
      if (next) next.disabled = (i === slides.length - 1);
      startProgress();
    }
    function go(i) {
      if (i < 0) i = slides.length - 1;
      if (i >= slides.length) i = 0;
      scrollToIndex(i);
      setActive(i);
      restart();
    }
    function tick() { go(current + 1); }
    function restart() {
      if (timer) clearTimeout(timer);
      if (playing) timer = setTimeout(tick, interval);
    }
    function setPlaying(on) {
      playing = on;
      if (pauseIc) pauseIc.textContent = on ? '❚❚' : '▶';
      if (on) { startProgress(); restart(); }
      else { if (timer) clearTimeout(timer); freezeProgress(); }
    }

    nums.forEach(function (n, idx) { n.addEventListener('click', function () { go(idx); }); });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    if (pauseBtn) pauseBtn.addEventListener('click', function () { setPlaying(!playing); });

    // sincronizar índice al hacer swipe manual
    var scrollT;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollT);
      scrollT = setTimeout(function () {
        var w = slides[0].getBoundingClientRect().width + 18;
        var i = Math.round(track.scrollLeft / w);
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (i !== current) { setActive(i); restart(); }
      }, 120);
    }, { passive: true });

    // pausar al pasar el mouse / cuando no está visible
    root.addEventListener('mouseenter', function () { if (playing && timer) { clearTimeout(timer); freezeProgress(); } });
    root.addEventListener('mouseleave', function () { if (playing) { startProgress(); restart(); } });

    setActive(0);
    restart();
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lp-heroc]').forEach(initHeroCarousel);
  });

  /* ---- Carrusel peek: flechas ---- */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lp-carousel]').forEach(function (car) {
      var track = car.querySelector('[data-lp-car-track]');
      var prev = car.parentNode.querySelector('[data-lp-car-prev]') || document.querySelector('[data-lp-car-prev]');
      var next = car.parentNode.querySelector('[data-lp-car-next]');
      // buscar flechas dentro de la misma sección
      var section = car.closest('section') || car.parentNode;
      prev = section.querySelector('[data-lp-car-prev]');
      next = section.querySelector('[data-lp-car-next]');
      if (!track) return;
      function step() {
        var slide = track.querySelector('.lp-carousel__slide');
        return slide ? slide.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      }
      function updateArrows() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  });

  /* ---- Mega menu (desktop hover + teclado) ---- */
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lp-megamenu]').forEach(function (root) {
      var items = root.querySelectorAll('[data-lp-mm-item]');
      items.forEach(function (item) {
        var panel = item.querySelector('[data-lp-mm-panel]');
        var trigger = item.querySelector('[data-lp-mm-trigger]');
        if (!panel || !trigger) return;
        var open = function () { item.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); };
        var close = function () { item.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); };
        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', close);
        trigger.addEventListener('focus', open);
        item.addEventListener('focusout', function (ev) { if (!item.contains(ev.relatedTarget)) close(); });
      });
    });
  });
})();
